<div class="container-fluid d-flex flex-column">
    <div class="row mb-1 d-flex">
        <div class="d-flex flex-wrap-reverse row-gap-1 justify-content-between align-items-center">
            <span class="col-2 w-330px">
                <app-search-input [inputSearchPlaceholder]="'Search by Value...'" 
                [inputSerachValue]="paginationBaseModel?.searchText"
                (inputSerachValueEmit)="searchRoleByText($event)"
                > </app-search-input>
            </span>
            <div class="d-flex flex-grow-1 justify-content-end">
                <app-button
                 class="px-1" 
                 [buttonLable]="enumButtonName.DELETE"
                 (click)="open_DeleteModal()"
                 [buttonClass]="idList && idList.length > 0 ? 'border-red' : 'border-grey cursor-notAllowed'"
                ></app-button>
                <app-button 
                  class="px-1"
                  imgUrl=""
                  [buttonLable]="enumButtonName.IMPORT"
                  [buttonClass]="'border-theme hand'"
                  (click)="openImport()"
                  ></app-button>
                <app-button
                 class="px-1"
                 imgUrl=""
                 (click)="addEditCodeGroupPopup()"
                 [buttonLable]="enumButtonName.ADD"
                 [buttonClass]="'border-theme'"
                 ></app-button>
                 <app-svg
                  iconType="Pin"
                  class="p-l-5 d-flex align-items-center"
                 (click)="pinned =!pinned; openFavouriteDockPopup(pinned)"
                 [ngClass]="pinned == true ? 'pinnedColor' : ''">
                </app-svg>

            </div>
        </div>
    </div>
    <app-ag-grid
    class="h-100 d-flex flex-column position-relative code-crosswalk"
    [dataModel]="agGridCodeCrosswalks"
    [columnSettings]="false"
    (gridReady)="onGridReady($event)"
    (onPagination)="onPagination($event)"
    (onSelectionChange)="onSelectionChange($event)"
    (onDeleteIconClick)="onDeleteIconClick($event)"
    (onEditIconClick)="onEditIconClick($event)"
  ></app-ag-grid>
</div>